export default __webpack_public_path__ + "static/media/ga_logo.0b5d6503.png";